module.exports = __webpack_public_path__ + "static/media/demo.1c511aa4.gif";